import { render, staticRenderFns } from "./BenefitClientsChart.vue?vue&type=template&id=428d3929&scoped=true"
import script from "./BenefitClientsChart.vue?vue&type=script&lang=js"
export * from "./BenefitClientsChart.vue?vue&type=script&lang=js"
import style0 from "./BenefitClientsChart.vue?vue&type=style&index=0&id=428d3929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d3929",
  null
  
)

export default component.exports